import { Utils } from "@flexday/common"
import { isPast, isToday } from "date-fns"
import { groupConsecutiveDates, formatDate } from "./utils"

const ReservationInfo = ({ cart, inventoryPageSnapshots, onRemove }) => {
  const isEmptyCart =
    Object.keys(cart).filter((k) => k !== "createdAt").length === 0

  return (
    <div className="flex flex-col md:flex-row gap-8">
      <div className="rounded-full bg-black font-bold text-2xl w-10 h-10 text-white flex items-center justify-center flex-shrink-0">
        1
      </div>

      <div>
        <p className="font-bold text-2xl whitespace-nowrap mb-4">
          Reservation Info.
        </p>

        {isEmptyCart ? (
          <p className="mb-8">Your cart is empty.</p>
        ) : (
          inventoryPageSnapshots.map((snapshot) => {
            const inventoryPage = snapshot.data()
            const inventoryInCart = cart[snapshot.ref.id]
            const groupedDates = groupConsecutiveDates(
              inventoryInCart.data.dates
            )

            return (
              <div
                key={`reservation-${snapshot.ref.id}`}
                className="flex flex-col gap-3">
                <p>{inventoryPage.name}</p>
                <p>{inventoryPage.address}</p>

                <div className="flex flex-col gap-1">
                  {groupedDates.map((dateGroup, idx) => {
                    const startDate = new Date(dateGroup.at(0))
                    const isValidRange =
                      !isPast(startDate) || isToday(startDate)

                    return (
                      <div
                        key={`dates-${idx}`}
                        className="flex gap-4 items-center">
                        <span
                          className={`${
                            isValidRange ? "bg-gray-200" : "bg-red-200"
                          } px-2 py-1 whitespace-nowrap w-48 text-center text-sm`}>
                          {formatDate(dateGroup.at(0))}
                        </span>
                        <span>-</span>
                        <span
                          className={`${
                            isValidRange ? "bg-gray-200" : "bg-red-200"
                          } px-2 py-1 whitespace-nowrap w-48 text-center text-sm`}>
                          {formatDate(dateGroup.at(-1))}
                        </span>
                      </div>
                    )
                  })}
                </div>

                {inventoryInCart.discount && (
                  <p className="text-xs italic text-[#652cb3]">
                    Woohoo! You got a discount on this team space for using it
                    for more than 2 days.
                  </p>
                )}

                <div className="flex gap-4 justify-end">
                  <a
                    href={getInventoryPageUrl(inventoryPage.name)}
                    className="self-end underline text-[#652cb3] text-sm">
                    Edit Order
                  </a>
                  <button
                    type="button"
                    onClick={() => onRemove(snapshot.ref.id)}
                    className="self-end underline text-red-500 text-sm">
                    Remove
                  </button>
                </div>
              </div>
            )
          })
        )}
      </div>
    </div>
  )
}

const getInventoryPageUrl = (inventoryPageName) => {
  const slug = Utils.slugifyName(inventoryPageName)

  return `${process.env.REACT_APP_FLEXDAY_URL}/suite/${slug}`
}

export default ReservationInfo
